import { tt } from '@agos/shared'

/**
 * Recording a Z-report that was performed on the register - §9.450, FB-771.
 *
 * **The owner:** *"in kasa in zásuvka there is 00.00 and on website we see 18,65"*. AGOS counts the
 * drawer from the last Z-report **it** recorded, and a *záverečka* run on the FiskalPro device
 * writes no such row - so the boundary never moved and AGOS kept showing cash the register had
 * already zeroed. Measured: the restaurant register's boundary was stuck at 2026-07-27 with 96,35
 * still counted as being in the drawer.
 *
 * **Asking the register was the obvious fix and is not available.** `xReport` and `zReport` return a
 * raw string and the device answers **`ACK`**; across all 1 153 stored closures **0** carry a
 * closure number and **0** a receipt count. So the only route is to let somebody say it happened,
 * which makes the wording part of the feature rather than decoration: this control records a claim.
 */

/** Why the button exists, said before it is pressed. */
export function declaredClosingNote(): string {
  return tt(
    'Ak ste dennú uzávierku vykonali priamo v pokladni, AGOS o tom nevie a zásuvka tu ukazuje aj hotovosť, ktorú pokladňa už vynulovala. Zaznamenajte to tu.',
  )
}

/**
 * What the confirmation says, and it says two things on purpose.
 *
 * That **nothing is sent to the register** - the operation already happened there, so this cannot
 * repeat it - and that the **drawer starts counting from now**, which is the whole effect and the
 * only thing that changes.
 */
export function declaredClosingConfirmation(): string {
  return tt(
    'Do pokladne sa nič neposiela - uzávierka už tam prebehla. Zaznamená sa len to, že sa stala, a zásuvka sa bude počítať odteraz.',
  )
}
